"use client";

import Breadcrumbs from "@/components/entities/breadcrumbs";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import { useTranslations } from "next-intl";
import { useReturnInfoData } from "../../hooks/useReturnInfoData";

const ReturnInfoContent = () => {
  const t = useTranslations();
  const { data } = useReturnInfoData();

  const breadcrumbs = [
    { title: t("home"), url: "/" },
    { title: t("cancellationPolicy"), url: "/return-information" },
  ];

  return (
    <Container className={S.wrapper}>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      {data?.description && <div className={S.infoWrapper} dangerouslySetInnerHTML={{ __html: data?.description }} />}
    </Container>
  );
};

export default ReturnInfoContent;
